import { LandingScreen } from 'components/landingScreen';

export const routes = [
	{ path: '/', title: 'Home', component: LandingScreen }
];
